/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import {
  DropDownContainer,
  DropDownHeader,
  DropDownListContainer,
  DropDownList,
  ListItem,
} from './styles';
import { useNavigate } from 'react-router-dom';
import { useSelectComponent } from '../../../hooks/hooks/useSelectComponent';

interface SelectProps {
  options: Array<any>;
  icon: string;
  nameSelect: string;
  isPerfil?: boolean;
  isTimer?: boolean;
  isCredor?: boolean;
}

export function Select({
  options,
  nameSelect,
  isPerfil,
  icon,
  isTimer,
  isCredor,
}: SelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const { onOptionSelected, selectedOptions, selectedCredorOption } =
    useSelectComponent();

  const navigate = useNavigate();

  const toggling = () => setIsOpen(!isOpen);

  useEffect(() => {
    if (isTimer && selectedOptions === '') {
      onOptionSelected(options[0]);
    }
  }, [isTimer, options, onOptionSelected]);

  // Usar isso para colocar filtro no estado.
  const onOptionClicked = (value: string) => () => {
    if (isTimer) {
      onOptionSelected(value);
      setIsOpen(false);
    } else if (isPerfil && value === 'Sair') {
      localStorage.removeItem('email');
      localStorage.removeItem('password');
      navigate('/');
    } else if (isCredor) {
      onOptionSelected(value, true);
      setIsOpen(false);
    }
  };

  return (
    <DropDownContainer className="select">
      <DropDownHeader
        onClick={toggling}
        isPerfil={isPerfil}
        isTimer={isTimer}
        isCredor={isCredor}
      >
        <p>
          {isTimer
            ? selectedOptions
            : selectedCredorOption && isCredor
            ? selectedCredorOption
            : nameSelect}
        </p>
        <img src={icon} alt="" />
      </DropDownHeader>
      {isOpen && (
        <DropDownListContainer isCredor={isCredor}>
          <DropDownList className="items">
            {options.map((option) => (
              <ListItem onClick={onOptionClicked(option)} key={Math.random()}>
                {option}
              </ListItem>
            ))}
          </DropDownList>
        </DropDownListContainer>
      )}
    </DropDownContainer>
  );
}
